import { CUSTOM_PROTOCOL } from '@/consts'
import { useUserInfo } from '@/store'
import { getImageUrl, getAuthStr } from '@/utils'
import { sealing } from '@/env'
import { ev } from '@/consts'

const getLocationStartUrl = () => {
  //为内嵌包添加到主屏幕时替换type
  const searchParams = new URLSearchParams(location.search)
  if (searchParams.get('type') === 'ebd') {
    searchParams.set('type', 'n')
    return location.origin + '/?' + searchParams.toString()
  }
  return location.origin + '/' + location.search
}

const manifest = {
  name: location.hostname,
  short_name: location.hostname,
  scope: location.origin + '/',
  start_url: getLocationStartUrl(),
  theme_color: 'black',
  background_color: 'black',
  display: 'standalone',
  icons: [
    {
      src: location.origin + '/static/images/logo-512.png',
      sizes: '512x512',
      type: 'image/png',
      purpose: 'any',
    },
  ],
  protocol_handlers: [
    {
      protocol: CUSTOM_PROTOCOL,
      url:
        location.origin +
        `/?pwaredirect=%s${sealing ? '&preventionJump=true&ak=i7pXJ7C0GRAFhqG' : ''}`,
    },
  ],
}

const createManifestLink = (json) => {
  const manifest = JSON.stringify(json)
  let link = document.createElement('link')
  link.rel = 'manifest'
  link.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(manifest)

  document.querySelector('link[rel="manifest"]')?.remove()
  document.head.appendChild(link)
}

const initHeadLinks = (pwaConfig: any) => {
  // if (pwaConfig.webTitle) document.title = pwaConfig.webTitle;
  if (pwaConfig.webDescription)
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', pwaConfig.webDescription)
  if (pwaConfig.webIcon)
    document
      .querySelectorAll('link[rel="apple-touch-icon"]')
      .forEach((link) =>
        link.setAttribute('href', getImageUrl(pwaConfig.webIcon)),
      )
  // if (pwaConfig.webPageIcon) {
  //   document.querySelector('link[rel="icon"]')?.setAttribute('href', getImageUrl(pwaConfig.webPageIcon));
  // }
  const userInfo = useUserInfo().userInfo
  let start_url = getLocationStartUrl()
  if (userInfo?.token) {
    start_url += (start_url.includes('?') ? '&' : '?') + getAuthStr(userInfo)
  }

  createManifestLink(
    Object.assign(manifest, {
      name: pwaConfig.pwaTitle,
      short_name: pwaConfig.pwaShortTitle,
      icons: [
        {
          src: getImageUrl(pwaConfig.pwaIcon),
          sizes: '512x512',
          type: 'image/png',
          purpose: 'any',
        },
      ],
      start_url,
    }),
  )
}

const updateManifest = () => {
  const userInfo = useUserInfo().userInfo
  let start_url = getLocationStartUrl()
  if (userInfo?.token) {
    start_url += (start_url.includes('?') ? '&' : '?') + getAuthStr(userInfo)
  }

  createManifestLink(manifest)
}

ev.on('login', (_isRestore: any) => {
  if (!_isRestore) updateManifest()
})

// ev.on('restore', (d: any) => {
//   if (d[0].userInfo && d[1].$id === 'userInfo') {
//     updateManifest()
//   }
// })

ev.on('logout', () => {
  updateManifest()
})

export default initHeadLinks
